if (!customElements.get('stockist-catalogue')) {
  customElements.define(
    'stockist-catalogue',
    class StockistCatalogue extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
        this.areaFilters = this.querySelector('[data-area-filters]');
        this.areaButtons = Array.from(this.querySelectorAll('[data-area-filter]'));
        this.areaSelect = this.querySelector('[data-area-select]');
        if (!this.tabs.length || !this.panels.length) return;

        this.onHashChange = this.onHashChange.bind(this);
        this.tabs.forEach((tab) => {
          tab.addEventListener('click', () => this.activate(tab.dataset.catalogueTab, true, this.activeArea));
          tab.addEventListener('keydown', (event) => this.onKeydown(event));
        });
        this.areaButtons.forEach((button) => {
          button.addEventListener('click', () => this.activate(this.activeTab, true, button.dataset.areaFilter));
        });
        this.areaSelect?.addEventListener('change', (event) => {
          this.activate(this.activeTab, true, event.currentTarget.value);
        });

        window.addEventListener('hashchange', this.onHashChange);
        this.classList.add('is-enhanced');
        this.sortCards();
        this.onHashChange();
      }

      disconnectedCallback() {
        window.removeEventListener('hashchange', this.onHashChange);
      }

      onHashChange() {
        const [requestedTab, requestedArea = 'all'] = window.location.hash.replace('#', '').split('/');
        const tabName = this.tabs.some((tab) => tab.dataset.catalogueTab === requestedTab)
          ? requestedTab
          : 'groceries';
        this.activate(tabName, false, requestedArea);
      }

      activate(tabName, updateHash, requestedArea = 'all') {
        this.activeTab = tabName;
        this.tabs.forEach((tab) => {
          const selected = tab.dataset.catalogueTab === tabName;
          tab.setAttribute('aria-selected', String(selected));
          tab.tabIndex = selected ? 0 : -1;
        });

        this.panels.forEach((panel) => {
          panel.hidden = panel.dataset.cataloguePanel !== tabName;
        });

        const allAreasControl = this.areaButtons.find((button) => button.dataset.areaFilter === 'all');
        const requestedControl = this.areaButtons.find((button) => button.dataset.areaFilter === requestedArea);
        const totalForTab = this.getAreaCount(allAreasControl, tabName);
        const requestedCount = this.getAreaCount(requestedControl, tabName);
        const areaName = requestedArea === 'all' || (requestedControl && requestedCount > 0) ? requestedArea : 'all';
        this.activeArea = areaName;

        if (this.areaFilters) this.areaFilters.hidden = totalForTab === 0;
        this.updateAreaControls(tabName, areaName);

        this.panels.forEach((panel) => {
          if (panel.dataset.cataloguePanel !== tabName) return;
          panel.querySelectorAll('[data-stockist-area]').forEach((area) => {
            area.hidden = areaName !== 'all' && area.dataset.stockistArea !== areaName;
          });
        });

        const nextHash = `#${tabName}${areaName === 'all' ? '' : `/${areaName}`}`;
        if (updateHash && window.location.hash !== nextHash) {
          window.location.hash = nextHash;
        }
      }

      getAreaCount(control, tabName) {
        if (!control) return 0;
        return Number.parseInt(control.getAttribute(`data-${tabName}-count`) || '0', 10);
      }

      updateAreaControls(tabName, areaName) {
        this.areaButtons.forEach((button) => {
          const count = this.getAreaCount(button, tabName);
          const isAllAreas = button.dataset.areaFilter === 'all';
          button.hidden = !isAllAreas && count === 0;
          button.setAttribute('aria-pressed', String(button.dataset.areaFilter === areaName));
          const countElement = button.querySelector('[data-area-count]');
          if (countElement) countElement.textContent = `(${count})`;
        });

        if (!this.areaSelect) return;
        Array.from(this.areaSelect.options).forEach((option) => {
          const count = this.getAreaCount(option, tabName);
          const isAllAreas = option.value === 'all';
          option.disabled = !isAllAreas && count === 0;
          option.hidden = !isAllAreas && count === 0;
          option.textContent = `${option.dataset.areaLabel} (${count})`;
        });
        this.areaSelect.value = areaName;
      }

      onKeydown(event) {
        const currentIndex = this.tabs.indexOf(event.currentTarget);
        let nextIndex;

        if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % this.tabs.length;
        if (event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = this.tabs.length - 1;
        if (nextIndex === undefined) return;

        event.preventDefault();
        const nextTab = this.tabs[nextIndex];
        nextTab.focus();
        this.activate(nextTab.dataset.catalogueTab, true, this.activeArea);
      }

      sortCards() {
        const collator = new Intl.Collator(document.documentElement.lang || undefined, { sensitivity: 'base' });
        this.querySelectorAll('[data-stockist-grid]').forEach((grid) => {
          Array.from(grid.children)
            .sort((a, b) => collator.compare(a.dataset.stockistName || '', b.dataset.stockistName || ''))
            .forEach((card) => grid.appendChild(card));
        });
      }
    }
  );
}
